import * as yup from 'yup'
import I18n from 'i18n-js'

const generateMessage = messageKey => {
  return ref => {
    let message = I18n.t(messageKey, { label: ref.label })
    return capitalize(message)
  }
}

const capitalize = string => `${string.charAt(0).toUpperCase()}${string.slice(1)}`

yup.setLocale({
  mixed: {
    default: generateMessage('validations.invalid'),
    required: generateMessage('validations.required'),
  },
  string: {
    email: generateMessage('validations.email'),
  },
})

export default yup
